import React, { useEffect, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { RETAIL_WHOLESALE, WHOLESALE_FORMAT } from 'codes';

// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// LOCAL VARIABLES
import { PURCHASE_TYPES } from '../variables';

// RENDER
const PurchaseInfoForm = () => {
 
  // FORMIK
  const { values, setFieldValue } = useFormikContext() || {};

  // MEMOS
  const {
    sale_type_id,
    sale_type_category_id,
    wholesale_format_id
  } = useMemo(
    () => values || {},
    [values]
  )
  const isLease = useMemo(
    () => +sale_type_id === 2,
    [sale_type_id]
  )
  const isWholesaleSimplified = useMemo(
    () => 
      +sale_type_category_id === RETAIL_WHOLESALE.wholesale.numeric &&
      +wholesale_format_id === WHOLESALE_FORMAT.simplified.numeric,
    [sale_type_category_id, wholesale_format_id]
  )

  useEffect(() => {
    if (isWholesaleSimplified) setFieldValue('sale_type_id', '1');
  }, [isWholesaleSimplified, setFieldValue]);
  
  // RENDER
  return (
    <Form.Body>
      <Form.Checklist
        name="sale_type_id"
        type="radio"
        label={{
          label: 'Purchase Type',
          disabled: false
        }}
        options={PURCHASE_TYPES}
        disabled={isWholesaleSimplified}
        required
      />
      <Form.Control label="Selling Price" name="selling_price" schema="dollars" required />
      {isLease && <>
        <Form.Control label="Lease Rate Reserve" name="lease_rate_reserve" schema="dollars" required />
        <Form.Control label="Warranty Reserve" name="lease_warranty_reserve" schema="dollars" required />
        <Form.Control label="Lease Split (F&I %)" name="lease_gross_split" schema="percent" required />
      </>}
    </Form.Body>
  )
}

export default function PurchaseInfo(props) {
  return <Card title="Purchase Info" body={<PurchaseInfoForm {...props} />} />;
}